import type { ContactFilterQuery } from "@/components/contact-query-builder/types";

export const CUSTOM_VIEW_VISIBILITY = {
  PRIVATE: "private",
  WORKSPACE: "workspace",
} as const;

export type CustomViewVisibility =
  (typeof CUSTOM_VIEW_VISIBILITY)[keyof typeof CUSTOM_VIEW_VISIBILITY];

export interface CustomView {
  id: string;
  name: string;
  icon: string;
  query: ContactFilterQuery;
  visibility: CustomViewVisibility;
  createdBy: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateCustomViewPayload {
  name: string;
  icon: string;
  query: ContactFilterQuery;
  visibility?: CustomViewVisibility;
}

export type UpdateCustomViewPayload = Partial<CreateCustomViewPayload>;
